import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const url = 'https://www.livewelldorset.co.uk/json/habithacker.json';
// const url = '/bcts';


export const getBCTs = createAsyncThunk('bcts', async (args, thunk) => {
    try {
        const response = await fetch(url).then((response) => response.json());

        const content = {
            alcohol: {},
            weight: {},
            smoking: {},
            activity: {},
        };

        for (let i = 0, l = response.length; i < l; i++) {
            let d = response[i];
            if (!d.web_friendly_barrier) continue;

            content[d.pathway][d.id] = {
                value: d.barrier,
                label: d.web_friendly_barrier?.replace('losing weight', 'managing weight'),
                bcts: {},
                id: d.id,
            };
            d.bcts.forEach((bct) => (content[d.pathway][d.id].bcts[bct.id] = bct));
        }
        return thunk.fulfillWithValue(content);
    } catch (error) {
        return thunk.rejectWithValue(error);
    }
});

const bctsSlice = createSlice({
    name: 'bcts',
    initialState: {
        alcohol: {},
        weight: {},
        smoking: {},
        activity: {},
    },
    extraReducers: (builder) => {
        builder.addCase(getBCTs.fulfilled, (state, action) => ({
            ...state,
            ...action.payload,
        }));

        builder.addCase(getBCTs.rejected, (state) => state);
    },
});

export default bctsSlice.reducer;
